export const CURRENT_CONSENT_VERSION = "v1";

export type AiChatApproval = {
  id: string;
  account_id: string;
  approved_by_uid: string;
  approved_by_email: string;
  consent_version: string;
  approved_at: string;
  created_at: string;
  revoked_at: string | null;
  revoked_by_uid: string | null;
};

export type GetApprovalStatusRequest = Record<string, never>;
export type GetApprovalStatusResponse = {
  approved: boolean;
  approval: AiChatApproval | null;
};
